import React from 'react';

import './LandingPageSection.scss';
import LandingPageTile from '../LandingPageTile/LandingPageTile';
import { toLowerKebabCase } from '../../../utils/utils';

const LandingPageSection = ({
  content,
  description,
  descriptionNotes,
  title,
}) => {
  return (
    <div
      className={`container ${toLowerKebabCase(
        title
      )}-container e2e-transaction-section landing-page-section-container`}
    >
      <div className="landing-page-section-description-container">
        <h3 className="college-branded-text landing-page-section-title">
          {title}
        </h3>
        <p className="landing-page-section-description">{description}</p>
        {descriptionNotes}
      </div>
      <div className="landing-page-section-tile-container">
        {content.map(({ component: PassedInComponent, icon, ...tileProps }) =>
          // PassedInComponent allows you to pass in a custom tile with an action other than
          // linking to an external link. (i.e.- opening a modal)
          PassedInComponent ? (
            <PassedInComponent
              key={tileProps.title}
              icon={icon}
              {...tileProps}
            />
          ) : (
            <LandingPageTile
              key={tileProps.title}
              icon={icon}
              sectionTitle={title}
              {...tileProps}
            />
          )
        )}
      </div>
    </div>
  );
};

export default LandingPageSection;
